import React from "react";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import Sidebar from "./Sidebar";
import { Box } from "@mui/material";
export default function Layout({ children }) {
  return (
    <>
      <Sidebar />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: "100vh",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box>
          <Header />
          <Box>{children}</Box>
        </Box>
        <Footer />
      </Box>
    </>
  );
}
